import React from 'react';
import Modal from '../../Atoms/Modal/Modal';
import styles from './TestimonialInfoModal.module.scss';
import Buttons from '../../Atoms/Buttons/Buttons';
import { useNavigate } from 'react-router-dom';
import doubleQuoteLeft from '../../../assets/Imagess/quotes-left.svg';
import doubleQuoteRight from '../../../assets/Imagess/qoutes-right.svg';
import he from 'he';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

const TestimonialInfoModal = ({
  data,
  handleOnClose,
  setShowDeletePopup,
  view,
}) => {
  const navigate = useNavigate();
  const decodedHTML = data ? he.decode(data?.testimonial_AR) : '';

  return (
    <Modal
      onClose={handleOnClose}
      width="1200px"
      modalInnerContainerStyle={{ padding: '0px' }}
      closeWhite={false}
    >
      <div className={styles['image-container']}>
        <img
          src={sanitizeAndValidateUrl(`${data?.url}${data?.testimonialImage}`)}
          className={styles['modal-image']}
        />
        <img
          className={styles['left-quotes']}
          src={doubleQuoteLeft}
          alt="Left Quote"
        />
        <img
          className={styles['right-quotes']}
          src={doubleQuoteRight}
          alt="Right Quote"
        />
        <div className={styles['right-border']}></div>
        <div className={styles['left-border']}></div>
        <div className={styles['right-top-border']}></div>
        <div className={styles['left-bottom-border']}></div>
        <div className={styles['bg-overlay']} />
        <div className={styles['text-title-container']}>
          <p>{data?.fullName_AR}</p>
        </div>
        <div className={styles['text-container']}>
          <p
            className={styles['text']}
            dangerouslySetInnerHTML={{ __html: decodedHTML }}
          />
        </div>
        <div className={styles['message-container']}>
          <p>{data?.messageAR}</p>
        </div>
      </div>
      {!view && (
        <div className={styles['info-container']}>
          <div className={styles['button-container']}>
            <Buttons
              text="تعديل"
              color="#0DA06E"
              rounded={true}
              style={{ width: '100%' }}
              type="submit"
              handleOnClick={() =>
                navigate(
                  `/home/update-speech/${
                    !data?.isTestimonial ? 'speech' : 'testimonial'
                  }/${data?.testimonialId}`
                )
              }
            />
            <Buttons
              text="حذف"
              color="#D72222"
              rounded={true}
              style={{ width: '100%' }}
              type="submit"
              handleOnClick={() => {
                handleOnClose();
                setShowDeletePopup(true);
              }}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default TestimonialInfoModal;
